import type { PlanChangeOptionsResponseDowngradeOptionsItem } from './planChangeOptionsResponseDowngradeOptionsItem';
import type { PlanChangeOptionsResponseUpgradeOptionsItem } from './planChangeOptionsResponseUpgradeOptionsItem';

export interface PlanChangeOptionsResponse {
  downgradeOptions?: PlanChangeOptionsResponseDowngradeOptionsItem[];
  upgradeOptions?: PlanChangeOptionsResponseUpgradeOptionsItem[];
}
